import { Box, Typography } from '@mui/material';
import Banner from '../global/Banner';
import useStripeAccountBanner from '../../hooks/stripe/useStripeAccountBanner';

function StripeAccountBanner() {
  const { isBannerShown, hideBanner, onViewStripeAccount } =
    useStripeAccountBanner();

  return (
    <Banner
      isVisible={isBannerShown}
      hideBanner={hideBanner}
      action={{ onClick: onViewStripeAccount }}>
      <Typography variant="h5" color="inherit">
        Your payments account is disabled.
      </Typography>
      <Box display={{ xs: 'none', sm: 'flex' }} gap={1} alignItems="center">
        <Typography
          variant="body2"
          color="inherit"
          marginLeft={1}
          sx={{
            // eslint-disable-next-line no-restricted-syntax -- typography-exception: banner link must beat the global anchor colour with !important; palette paths cannot carry !important
            color: '#ffffff !important',
          }}>
          View Stripe Account
        </Typography>
      </Box>
    </Banner>
  );
}

export default StripeAccountBanner;
